import { useRef, useState, useEffect } from 'react';

function getScrollPercentage(element) {
    if (element === null) {
        return NaN;
    }
    const height = element.scrollHeight - element.clientHeight;

    return Math.round((element.scrollTop / height) * 100);
}

export default function useScrollPercentage() {
    const scrollRef = useRef(null);
    const [scrollPercentage, setScrollPercentage] = useState(NaN);

    const reportScroll = e => {
        setScrollPercentage(getScrollPercentage(e.target));
    };

    useEffect(() => {
        const node = scrollRef.current?.children?.[0]?.children?.[0];
        if (node) {
            node.addEventListener('scroll', reportScroll, { passive: true });
            if (Number.isNaN(scrollPercentage)) {
                setScrollPercentage(getScrollPercentage(node));
            }
        }

        return () => {
            if (node) {
                node.removeEventListener('scroll', reportScroll);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollPercentage, scrollRef.current?.children[0]?.children]);

    return [scrollRef, Number.isNaN(scrollPercentage) ? 0 : scrollPercentage];
}
